import { observable } from "mobx";

export class User {
    @observable registrationApp: string;
    @observable catalogId: string;
    @observable fullName: string;
    @observable id: string;
    @observable isActivated: boolean;
    @observable phoneNumber: string;
    @observable vendorEmail: string;
    @observable vendorId: string;
    @observable vendorName: string;
    @observable orgId: string;
    @observable salesRepMatchId: Array<string>;
    @observable role: string;
    @observable roles: Array<string>;

    constructor() {
        this.registrationApp = "";
        this.catalogId = "";
        this.fullName = "";
        this.id = "";
        this.isActivated = false;
        this.phoneNumber = "";
        this.vendorEmail = "";
        this.vendorId = "";
        this.vendorName = "";
        this.orgId = "";
        this.salesRepMatchId = [];
        this.role = "";
        this.roles = [];
    }
}